import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { BoardState } from "./BoardState";
import { GameManager } from "../GameManager";
import { Piece } from "./Piece";
import { Board } from "./Board";

export class BoardManagerAI {

    private static game: Phaser.Game;
    
    private static promotionEndPosition: string;
    private static kingInCheck: boolean; 
    private static p4State: P4State;
    private static p4Object: any;
    private static timerEvent: Phaser.TimerEvent;
    private static showStartLayer: boolean;

    public static init (game: Phaser.Game) {

        BoardManagerAI.game = game;

        GameVars.leftBlackKnightInstantiated = false;
        GameVars.leftWhiteKnightInstantiated = false;

        BoardManagerAI.promotionEndPosition = null;
        BoardManagerAI.kingInCheck = false;
        BoardManagerAI.timerEvent = null;

        GameVars.gamePaused = false;
        GameVars.capturedPiece = null;
        GameVars.selectedPiece = null;
        GameVars.time = 0;
        GameVars.resigning = false;
        GameVars.playerResignedAIGame = false;

        this.showStartLayer = true;

        GameVars.fen = GameConstants.FEN_START;
        GameVars.colorPlayer = GameConstants.WHITE;
        GameVars.difficulty = GameConstants.DIFFICULTY_EASY;
        GameVars.startTime = null;
        GameVars.capturedPieces = [];
    
        // TODO: PARTIDA CASI GANADA
        // GameVars.fen = "6k1/P5bp/5Qp1/8/8/2B5/5PPP/6K1 w - - 0 1";

        GameVars.chess.load(GameVars.fen);

        if (GameVars.playerResignedAIGame || GameVars.chess.in_stalemate() || GameVars.chess.in_checkmate()) {
            GameVars.gameFinished = true;
        } else  {
            GameVars.gameFinished = false;
            GameVars.stalemate = false;
        } 

        BoardManagerAI.setBoard(); 
    }

    public static shutdown(): void {

        if (BoardManagerAI.timerEvent) {
            BoardManagerAI.timerEvent.pendingDelete = true;
        } 
    }

    public static setBoard(): void {

        BoardState.currentInstance.setBoard(this.showStartLayer);

        if (!this.showStartLayer) {
            BoardManagerAI.startGame();
        }
    }

    public static startGame(): void {

        GameVars.colorAndDifficultyUnselected = false;

        BoardManagerAI.startTimer();
        
        // determinar de quien es el turno en base al FEN
        BoardManagerAI.setTurn();

        BoardState.currentInstance.startGame();
        
        BoardManagerAI.p4State = p4_fen2state(GameVars.fen); 

        // podria darse el caso de una partida enb la que el jugador se rindio, que ha acabado en stalemate o checkmate
        if (GameVars.playerResignedAIGame) {
            BoardManagerAI.resign();
        } else if (GameVars.chess.in_stalemate()) {
            GameVars.winnerId = GameConstants.DRAW;
            BoardState.currentInstance.stalemate();
        } else if (GameVars.chess.in_checkmate()) {
            // GameVars.winnerId = GameVars.colorPlayer === GameVars.currentTurn ? GameConstants.COMPUTER_ID : GameVars.playerData.id;
            BoardState.currentInstance.checkmate();
        } else {

            // temporalmente
            if (GameVars.currentTurn !== GameVars.colorPlayer) {
                BoardManagerAI.game.time.events.add(1500, BoardManagerAI.iaMove, BoardManagerAI);
            }
        }  
    }

    public static setPlayerColor(color: string): void {

        GameVars.colorPlayer = color;       
        BoardState.currentInstance.playerColorSet();
    }

    public static setDifficulty(difficulty: string): void {

        GameVars.difficulty = difficulty;
    }

    public static startTimer(): void {

        if (GameVars.startTime === null) {

            GameVars.startTime = Math.floor(new Date().getTime() / 1000);
        }

        BoardManagerAI.timerEvent = this.game.time.events.loop(Phaser.Timer.SECOND, BoardManagerAI.onSecondPassed, this);
    }

    public static onSecondPassed(): void {

        let currentTime = Math.floor(new Date().getTime() / 1000);
        GameVars.time = currentTime - GameVars.startTime;
    }

    public static rematch(): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            LaggedAPI.APIAds.show("interstitial", "go-chicken-go", "go-chicken-go-game.png", function(response: any) {
                if (response.success) {
                    console.log("ad done");
                    GameManager.rematch();
                } else {
                    console.log("ad error, continue");
                    GameManager.rematch();
                }
            });
        } else {
            GameManager.rematch();
        }
    }

    public static onClickPause(): void {

        GameVars.gamePaused = true;
        BoardState.currentInstance.showPauseLayer();
    }

    public static exitPauseMenu(): void {

        GameVars.gamePaused = false;
        BoardState.currentInstance.hidePauseLayer();
    }

    public static pieceSelected(piece: Piece): void {

        if (GameVars.selectedPiece) {
            GameVars.selectedPiece.unselect();
        }

        GameVars.selectedPiece = piece;

        const board: Board = piece.board;

        const validMoves: string[] = GameVars.chess.moves({square: piece.p});

        for (let i: number = 0, ln: number = validMoves.length; i < ln; i++) {
            validMoves[i] = GameVars.getBoardPosition(validMoves[i]);
        }

        board.clearMarkers();
        board.showMarkers(validMoves);
    }

    public static movePlayerSelectedPiece(endPosition: string): void {

        if (GameVars.startTime === null) {
            BoardManagerAI.startTimer();
        }

        let board: Board = BoardState.currentInstance.board;
        
        let pawnPromotion: boolean = BoardManagerAI.checkPawnPromotion(endPosition);

        if (pawnPromotion) {

            BoardManagerAI.promotionEndPosition = endPosition;

            // ver si se ha capturado alguna pieza
            let capturedPiece = board.getPieceAt(endPosition);
            
            if (capturedPiece) {

                BoardState.currentInstance.hud.pieceCaptured(capturedPiece);
                board.removePiece(capturedPiece);
                GameVars.capturedPieces.push(capturedPiece.pieceType);        
            }

            board.clearMarkers();
            GameVars.selectedPiece.unselect();
            GameVars.selectedPiece.moveToPromotionPosition(endPosition);
            BoardState.currentInstance.showPawnPromotionMenu();

        } else {

            // notificar a chess
            let m: Move = {from: GameVars.selectedPiece.p, to: endPosition};

            m = GameVars.chess.move(m);
            
            BoardManagerAI.p4State.move(GameVars.selectedPiece.p, endPosition);

            // ver si se ha capturado alguna pieza
            BoardManagerAI.checkIfPieceHasBeenCaptured(m, endPosition);

            board.clearMarkers();
            board.moveSelectedPiece(m);

            BoardState.currentInstance.hud.accountMovement();
        }
    }

    public static promotionPieceSelectedByPlayer(promotedPiece: string): void {

        BoardState.currentInstance.removePawnPromotionLayer();

        let startPosition: string = GameVars.selectedPiece.p;

        // notificar a chess
        GameVars.chess.move({from: startPosition, to: BoardManagerAI.promotionEndPosition, promotion: promotedPiece});

        // cambiar el tipo de la pieza
        // para la promocion chess usa minusculas
        let promotion: number;

        if (promotedPiece === GameConstants.BLACK_ROOK) {
            promotion = 4;
        }

        if (promotedPiece === GameConstants.BLACK_KNIGHT) {
            promotion = 6;
        }

        if (promotedPiece === GameConstants.BLACK_BISHOP) {
            promotion = 8;
        }

        if (promotedPiece === GameConstants.BLACK_QUEEN) {
            promotion = 12;
        }

        // notificar al p4
        BoardManagerAI.p4State.move(startPosition, BoardManagerAI.promotionEndPosition, promotion);

        // determinar el turno y grabar el estado
        BoardManagerAI.setTurn();

        BoardManagerAI.game.time.events.add(450, function(): void {
            GameVars.selectedPiece.promoteTo(promotedPiece);
        }, BoardManagerAI);

        GameVars.capturedPiece = null; // por si las moscas
        GameVars.selectedPiece.p = BoardManagerAI.promotionEndPosition;
        BoardManagerAI.onPieceArrivedToItsPosition();
    }

    public static onPieceArrivedToItsPosition(): void {

        // determinar el turno y grabar el estado
        BoardManagerAI.setTurn();

        if (GameVars.capturedPiece) {

            BoardState.currentInstance.hud.pieceCaptured(GameVars.capturedPiece);

            let board: Board = BoardState.currentInstance.board;
            board.removePiece(GameVars.capturedPiece);
            GameVars.capturedPieces.push(GameVars.capturedPiece.pieceType);     
        }

        if (GameVars.chess.in_check()) {
            BoardManagerAI.check();
        } else if (BoardManagerAI.kingInCheck) {
            BoardManagerAI.uncheck();
        }

        // mirar si se ha producido jaque mate
        if (GameVars.chess.in_stalemate()) {
            BoardManagerAI.stalemate();
        } else if (GameVars.chess.in_checkmate()) {
            BoardManagerAI.checkmate();
        } else {
            // poner un delay
            if (GameVars.currentTurn !== GameVars.colorPlayer) {
                if (GameVars.chess.in_check()) {
                    this.game.time.events.add(2000, function(): void {
                        BoardManagerAI.iaMove();
                    }, this);
                } else {
                    BoardManagerAI.iaMove();
                }
            }
        }
    }

    public static resign(): void {

        GameVars.playerResignedAIGame = true;
        GameVars.gameFinished = true;
        GameVars.winnerId = GameConstants.COMPUTER_ID;

        if (BoardManagerAI.kingInCheck) {
            BoardManagerAI.kingInCheck = false;
            BoardManagerAI.uncheck();
        } 
        
        BoardState.currentInstance.checkmate();
    }

    public static leaveRoom(gameEnded?: boolean): void {

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED && gameEnded) {
            LaggedAPI.APIAds.show("interstitial", "go-chicken-go", "go-chicken-go-game.png", function(response: any) {
                if (response.success) {
                    console.log("ad done");
                    GameManager.leaveRoom();
                } else {
                    console.log("ad error, continue");
                    GameManager.leaveRoom();
                }
            });
        } else {
            GameManager.leaveRoom();
        }
    }

    private static iaMove(): void {

        if (GameVars.startTime === null) {
            BoardManagerAI.startTimer();
        }

        let difficulty: number = 1;
        let delay: number = 0;

        switch (GameVars.difficulty) {
            case GameConstants.DIFFICULTY_EASY:
                difficulty = 1;
                delay = 350;
                break;
            case GameConstants.DIFFICULTY_MEDIUM:
                difficulty = 2;
                delay = 200;
                break;
            case GameConstants.DIFFICULTY_HARD:
                difficulty = 4;
                delay = 100;
                break;
            default:
                break;
        }

        // salimos de este thread y se pone el icono de pensar
        BoardManagerAI.game.time.events.add(delay, function(): void {

            let proposedMovement: number[] = BoardManagerAI.p4State.findmove(difficulty);

            // convertir el movimiento propuesto a un string
            // para que chess y p4 puedan tomarlo como inputs
            let start: string = BoardManagerAI.convertMovementToString(proposedMovement[0]);
            let end: string = BoardManagerAI.convertMovementToString(proposedMovement[1]);
            
            BoardManagerAI.p4Object = BoardManagerAI.p4State.move(start, end);

                // se pone en un timer para evitar q el juego se quede parado
            BoardManagerAI.game.time.events.add(350, function(): void {

                let board: Board = BoardState.currentInstance.board;   
                let moveString: string = BoardManagerAI.p4Object.string;

                // ver si se ha producido una promocion
                let promotedPiece: string = BoardManagerAI.checkIfPieceHasBeenPromoted(moveString);
    
                // notificar a chess
            
                let m: Move = GameVars.chess.move({from: start, to: end, promotion: promotedPiece});

                // mirar si se ha capturado alguna pieza
                BoardManagerAI.checkIfPieceHasBeenCaptured(m, end);

                // mover la pieza del tablero
                GameVars.selectedPiece = board.getPieceAt(start);

                board.moveSelectedPiece(m);
                    
                BoardState.currentInstance.hud.accountMovement();
            }, BoardManagerAI);  

            }, BoardManagerAI);
    }

    private static convertMovementToString(mov: number): string {

        let col: number = mov % 10;
        let row: number =  Math.floor(mov / 10);

        let c: string  = GameConstants.COLUMNS[col - 1];
        let r: string = (row - 1).toString();

        return c + r;
    }

    private static checkIfPieceHasBeenCaptured(move: Move, endPosition: string): void {

        if (move === null) {
            return;
        }

        GameVars.capturedPiece = null;

        const board = BoardState.currentInstance.board;

        if (typeof move["captured"] !== "undefined") {

            let i = move.san.indexOf("x");
            let p = move.san.slice( i + 1, i + 3);

            GameVars.capturedPiece = board.getPieceAt(p);

            if (!GameVars.capturedPiece && (move.captured === GameConstants.BLACK_PAWN || move.captured === GameConstants.WHITE_PAWN)) {
                
                // se ha producido un EN PASSANT
                let p: string;
                let to: string = move.to;
                let row: number = parseInt(to[1]);

                if (move.color === GameConstants.WHITE) {
                    row --;
                } else {
                    row ++;
                }

                p = to[0] + row.toString();

                GameVars.capturedPiece = board.getPieceAt(p);
            }
        }

        // por si esto fallase usamos la endPosition
        if (!GameVars.capturedPiece) {
            GameVars.capturedPiece = board.getPieceAt(endPosition);
        }
    }

    private static checkPawnPromotion(end: string): boolean {

        // mirar si la fila es la 8 o la 1 y la pieza en cuestion es un peon
        if ((end[1] === GameConstants.ROWS[0] || end[1] === GameConstants.ROWS[7])
            && (GameVars.selectedPiece.pieceType === GameConstants.WHITE_PAWN || GameVars.selectedPiece.pieceType === GameConstants.BLACK_PAWN )) {
            return true;
        }

        return false;
    }

    private static stalemate(): void {

        if (BoardManagerAI.timerEvent) {
            BoardManagerAI.timerEvent.pendingDelete = true;
        }

        GameVars.gameFinished = true;
        GameVars.stalemate = true;
        GameVars.winnerId = GameConstants.DRAW;

        BoardState.currentInstance.stalemate();
    }

    private static checkmate(): void {

        if (BoardManagerAI.timerEvent) {
            BoardManagerAI.timerEvent.pendingDelete = true;
        }
        
        BoardManagerAI.uncheck();

        GameVars.gameFinished = true;

        // GameVars.winnerId = GameVars.colorPlayer === GameVars.currentTurn ? GameConstants.COMPUTER_ID : GameVars.playerData.id;

        BoardState.currentInstance.checkmate();
    }

    private static check(uploadedGame?: boolean): void {

        BoardManagerAI.kingInCheck = true;
        BoardState.currentInstance.check(uploadedGame);
    }

    private static uncheck(): void {

        BoardManagerAI.kingInCheck = false;
        BoardState.currentInstance.uncheck();
    }

    private static checkIfPieceHasBeenPromoted(movString: string): string {

        // encontrar la letra que hay inmediatamente despues de "=" si la hubiese
        let i: number = movString.indexOf("=");
        
        if (i !== -1) {

            let p: string = movString[i + 1];
            let ret: string;

            switch (p) {

                case "Q":
                    ret = GameConstants.BLACK_QUEEN;
                    break;

                case "B":
                    ret = GameConstants.BLACK_BISHOP;
                    break;
                
                case "R":
                    ret = GameConstants.BLACK_ROOK;
                    break;

                case "N":
                    ret = GameConstants.BLACK_KNIGHT;
                    break;
            
                default:
                    ret = null;
                    break;
            }

            return ret;

        } else {
            return null;
        }
    }

    private static setTurn(): void {

        GameVars.fen = GameVars.chess.fen();

        let tmpArray: string[] = GameVars.fen.split("/");
        tmpArray = tmpArray[7].split(" ");
        GameVars.currentTurn = tmpArray[1];
    }
}
